import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IdleCars {
  fifteen_min: number;
  thirty_min: number;
  forty_five_min: number;
}

interface CarStatus {
  pending_repair: number;
  obd_unplugged: number;
  cars_allotted_today: number;
  idle_cars: IdleCars;
}

interface CarStatusState {
  car_status: CarStatus | null;
}

const initialState: CarStatusState = {
  car_status: null,
};

const carStatusSlice = createSlice({
  name: "carStatus",
  initialState,
  reducers: {
    setCarStatus(state, action: PayloadAction<CarStatus>) {
      state.car_status = action.payload;
    },
  },
});

export const { setCarStatus } = carStatusSlice.actions;

export default carStatusSlice.reducer;
